export type AppLanguageCode = 'gb' | 'es' | 'fr' | 'sw' | 'pt' | 'uk' | 'tr'

export type AppLanguage = {
  code: AppLanguageCode
  /** ISO 3166-1 alpha-2 code for flag-icons */
  flagCode: string
  /** Display name in the language itself */
  nativeName: string
}

export const APP_LANGUAGES: AppLanguage[] = [
  { code: 'gb', flagCode: 'gb', nativeName: 'English' },
  { code: 'es', flagCode: 'es', nativeName: 'Español' },
  { code: 'fr', flagCode: 'fr', nativeName: 'Français' },
  { code: 'sw', flagCode: 'tz', nativeName: 'Kiswahili' },
  { code: 'pt', flagCode: 'pt', nativeName: 'Português' },
  { code: 'uk', flagCode: 'ua', nativeName: 'Українська' },
  { code: 'tr', flagCode: 'tr', nativeName: 'Türkçe' },
]

export const DEFAULT_APP_LANGUAGE_CODE: AppLanguageCode = 'gb'

export function findAppLanguage(code: string): AppLanguage | undefined {
  return APP_LANGUAGES.find((language) => language.code === code)
}

export function getAppLanguageOrDefault(code: string): AppLanguage {
  return findAppLanguage(code) ?? APP_LANGUAGES[0]
}
